/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const LOGIN_URL = `${process.env.BACKEND_API_URL}api/login`;
const CHECK_AUTH = `${process.env.BACKEND_API_URL}api/auth/check`;

const state = {
  user: {
    hasPricingRules: false,
    authenticated: false,
    data: {
      selectedRole: {},
      id: null,
    },
    paymentModuleEnabled: false,
    paymentMenuVisible: false,
    poolParkingEnabled: false,
    autopayEnabled: false,
    show_parking_spots_map: false,
    landlord_theme: '',
  },
  error: '',
};

const getters = {
  user: state => state.user,
  error: state => state.error,
};

const actions = {
  login({ commit }, payload) {
    return Vue.http.post(LOGIN_URL, payload)
      .then(async (response) => {
        Vue.http.headers.common.Authorization = `Bearer ${response.data.token}`;
        localStorage.setItem('id_token', response.data.token);
        await localStorage.setItem('user', JSON.stringify(response.data.user));
        commit(mTypes.DATA_ERROR, '');
        commit(mTypes.LOG_IN);
        return response.data.user;
      }).catch((error) => {
        commit(mTypes.DATA_ERROR, error.status);
      });
  },
  logout({ commit }) {
    return commit(mTypes.LOG_OUT);
  },
  checkAuth({ commit }, userData) {
    const finalUrl = userData && userData.selectedRole ? `${CHECK_AUTH}?id=${userData.selectedRole.id}&role=${userData.selectedRole.role}` : CHECK_AUTH;

    return Vue.http.get(finalUrl).then((response) => {
      commit('set-payment-module-status', response.data.payment_module_enabled);
      commit('set-payment-menu-visible', response.data.show_payment_menu_link);
      commit('set-pool-parking-status', response.data.pool_parking_enabled);
      commit('set-autopay-enabled', response.data.autopay_enabled);
      commit('set-show-parking-spots-map', response.data.show_parking_spots_map);
      commit('set-theme-class', response.data.landlord_theme);
      if (localStorage.getItem('id_token')) {
        commit(mTypes.LOG_IN);
      } else {
        commit(mTypes.LOG_OUT);
      }
    }).catch(() => {
      commit(mTypes.LOG_OUT);
    });
  },
  switchRole({ commit }, payload) {
    return commit(mTypes.SWITCH_ROLE, payload);
  },
};

const mutations = {
  [mTypes.LOG_IN](state) {
    state.user.data = JSON.parse(localStorage.getItem('user'));
    state.user.authenticated = true;
  },
  [mTypes.LOG_OUT](state) {
    localStorage.removeItem('id_token');
    localStorage.removeItem('user');
    state.user.authenticated = false;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
  [mTypes.SWITCH_ROLE](state, payload) {
    state.user.data.selectedRole = payload;
    localStorage.setItem('user', JSON.stringify(state.user.data));
  },
  ['set-payment-module-status'](state, status) {
    state.user.paymentModuleEnabled = status
  },
  ['set-payment-menu-visible'](state, status) {
    state.user.paymentMenuVisible = status
  },
  ['set-pool-parking-status'](state, status) {
    state.user.poolParkingEnabled = status;
  },
  ['set-autopay-enabled'](state, status) {
    state.user.autopayEnabled = status
  },
  ['set-show-parking-spots-map'](state, status) {
    state.user.show_parking_spots_map = status
  },
  ['set-theme-class'](state, status) {
    state.user.landlord_theme = status
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/user.js